<template>
  <div id="card">
    <header>上传照片</header>
    <section class="toast" v-if="toastStatus">
      <div>
        <Col class="demo-spin-col" span="8">
          <Spin fix>
            <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
            <div>上传中，请稍等</div>
          </Spin>
        </Col>
      </div>
    </section>
    <main>
      <div v-show="show == 0">
        <div class="uploadBox">
          <div class="uploadItem">
            <div class="itemTit">身份证正面</div>
            <div class="imgBox">
              <div class="examples">
                <img src="../assets/imgs/authentication/back.png" alt="" />
              </div>
              <div class="img" v-show="cpCardFrontImg">
                <img :src="cpCardFrontImgUrl" alt="" class="uploadImg" />
                <img src="../assets/imgs/authentication/del.png" alt="" class="close" @click="delImg(1)" />
              </div>
              <div class="cameraBox" v-show="!cpCardFrontImg">
                <input type="file" id="file" accept="image/*" @change="uploadCpFont" />
                <div class="cameraBox_son">
                  <img src="../assets/image/camera.png" alt="" />
                  <div>点击拍照上传照片</div>
                </div>
              </div>
            </div>
          </div>
          <div class="uploadItem">
            <div class="itemTit">身份证反面</div>
            <div class="imgBox">
              <div class="examples">
                <img src="../assets/imgs/authentication/font.png" alt="" />
              </div>
              <div class="img" v-show="cpCardRearImg">
                <img :src="cpCardRearImgUrl" alt="" class="uploadImg" />
                <img src="../assets/imgs/authentication/del.png" alt="" class="close" @click="delImg(2)" />
              </div>
              <div class="cameraBox" v-show="!cpCardRearImg">
                <input type="file" id="file1" accept="image/*" @change="uploadCpBack" />
                <div class="cameraBox_son">
                  <img src="../assets/image/camera.png" alt="" />
                  <div>点击拍照上传照片</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="msgBox">
          <p class="msgTit">资料要求</p>
          <div>· 清晰拍摄正反面、不能反光</div>
          <div>· 请注意露出四个边角，不要压边拍摄</div>
        </div>
      </div>

      <div class="successBox" v-if="show == 1">
        <img src="../assets/image/bigsuccess.png" alt="" />
        <p>上传成功</p>
      </div>
      <div class="failBox" v-if="show == 2">
        <img src="../assets/image/bigfail.png" alt="" />
        <p>上传失败</p>
        <div @click="repetitionUpload">重新上传</div>
      </div>
    </main>
    <footer v-show="show == 0" @click="submit">提交</footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: 0,
      toastStatus: false,
      cpCardFrontImgUrl: '',
      cpCardFrontImg: '',
      cpCardRearImg: '',
      cpCardRearImgUrl: '',
      sessionId: '',
      userId: ''
    };
  },
  created() {
    let href = window.location.href;
    this.sessionId = href.split('?')[1].split('&')[0];
    this.userId = href.split('?')[1].split('&')[1];
    // let session = JSON.parse(localStorage["session"]);
    // this.sessionId = session.sessionId;
    // this.userId = session.userId;
  },
  mounted() {
    this.$Message.config({
      top: 100
    });
  },
  methods: {
    submit() {
      if (this.cpCardFrontImg && this.cpCardRearImg) {
        let urlData = {
          frontPhoto: this.cpCardFrontImg,
          backPhoto: this.cpCardRearImg
        };
        let data = {
          modeCode: '5HsKvDD6VcfbPXX5LyVfFnxi9QXWm5Xr',
          sessionId: this.sessionId,
          userId: this.userId,
          data: JSON.stringify(urlData)
        };
        this.$http.post(data).then((res) => {
          if (res.code != 1) {
            this.show = 2;
          } else {
            this.show = 1;
          }
        });
      } else {
        this.$Message.error('请上传完整！');
      }
    },
    repetitionUpload() {
      this.show = 0;
      this.cpCardFrontImgUrl = '';
      this.cpCardFrontImg = '';
      this.cpCardRearImg = '';
      this.cpCardRearImgUrl = '';
    },
    delImg(index) {
      switch (index) {
        case 1:
          this.cpCardFrontImg = '';
          this.cpCardFrontImgUrl = '';
          break;
        case 2:
          this.cpCardRearImgUrl = '';
          this.cpCardRearImg = '';
          break;
        default:
          break;
      }
    },
    // 身份证正面
    uploadCpFont(event) {
      const files = event.target.files;
      let that = this;
      let image = files[0]; //获取文件域中选中的图片
      let reader = new FileReader(); //实例化文件读取对象
      reader.readAsDataURL(image); //将文件读取为 DataURL,也就是base64编码
      that.toastStatus = true;
      reader.onload = function (ev) {
        //文件读取成功完成时触发
        let dataURL = ev.target.result; //获得文件读取成功后的DataURL,也就是base64编码
        that.cpCardFrontImgUrl = dataURL;
        let data = {
          modeCode: 'DF6ylrACPgiTD0PGgs9F2l0yZHyiEO2M',
          sessionId: that.sessionId,
          userId: that.userId,
          fileName: encodeURIComponent(image.name),
          ocrType: 0,
          group: 'other', //其他分组
          sendRabbitMsg: 1
        };
        let base64 = encodeURIComponent(dataURL);
        that.$http.upload(data, base64).then((res) => {
          that.toastStatus = false;
          if (res.code == 1) {
            that.cpCardFrontImg = res.msg;
          } else {
            that.$Message.error(res.msg);
          }
        });
      };
    },
    // 身份证背面
    uploadCpBack(event) {
      const files = event.target.files;
      let that = this;
      let image = files[0]; //获取文件域中选中的图片
      let reader = new FileReader(); //实例化文件读取对象
      reader.readAsDataURL(image); //将文件读取为 DataURL,也就是base64编码
      that.toastStatus = true;
      reader.onload = function (ev) {
        //文件读取成功完成时触发
        let dataURL = ev.target.result; //获得文件读取成功后的DataURL,也就是base64编码
        that.cpCardRearImgUrl = dataURL;
        let data = {
          modeCode: 'DF6ylrACPgiTD0PGgs9F2l0yZHyiEO2M',
          sessionId: that.sessionId,
          userId: that.userId,
          fileName: encodeURIComponent(image.name),
          ocrType: 0,
          group: 'other', //其他分组
          sendRabbitMsg: 1
        };
        let base64 = encodeURIComponent(dataURL);
        that.$http.upload(data, base64).then((res) => {
          that.toastStatus = false;
          if (res.code == 1) {
            that.cpCardRearImg = res.msg;
          } else {
            that.$Message.error(res.msg);
          }
        });
      };
    }
  }
};
</script>

<style lang="less" scoped>
#card {
  header {
    background: #2c59c3;
    color: #fff;
    height: 45px;
    line-height: 45px;
    text-align: center;
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #ffffff;
    letter-spacing: 0.26px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
  }

  .toast {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.4);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      width: 150px;
      border-radius: 8px;
    }
  }

  main {
    box-sizing: border-box;
    margin-top: 50px;
    margin-bottom: 200px;
    height: calc(100vh - 90px);
    padding: 10px;

    .uploadBox {
      &:first-child {
        border-bottom: 1px solid #efefef;
      }

      .uploadItem {
        &:last-child {
          margin-bottom: 5px;
        }

        .itemTit {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #4a4a4a;
          letter-spacing: 0;
        }

        .imgBox {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 10px 0 15px;

          .examples {
            width: 48%;
            height: 106px;

            img {
              width: 100%;
            }
          }

          .cameraBox {
            width: 47%;
            height: 106px;
            background-color: #f8f8f8;
            position: relative;

            // margin-bottom: 15px;
            input {
              width: 100%;
              height: 106px;
              opacity: 0;
              position: absolute;
              top: 0;
              left: 0;
              z-index: 100;
            }

            .cameraBox_son {
              width: 100%;
              height: 106px;
              position: absolute;
              top: 0;
              left: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;

              div {
                font-family: PingFangSC-Regular;
                font-size: 10px;
                color: #e4e4e4;
                letter-spacing: 0.19px;
                margin-top: 15px;
              }
            }
          }

          .img {
            width: 48%;
            height: 106px;
            position: relative;

            .uploadImg {
              width: 100%;
              height: 100%;
            }

            .close {
              position: absolute;
              top: -8px;
              right: -8px;
            }
          }
        }
      }
    }

    .bottom {
      margin-top: 15px;
    }

    .msgBox {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #4a4a4a;
      letter-spacing: 0;

      .msgTit {
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #4a4a4a;
        letter-spacing: 0;
        font-weight: 600;
      }
    }

    .successBox {
      text-align: center;

      img {
        margin-top: 114px;
      }
    }

    .failBox {
      text-align: center;

      img {
        margin-top: 114px;
      }

      p {
        margin-bottom: 146px;
      }

      div {
        width: 200px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        border: 2px solid #3d8ff7;
        border-radius: 49.5px;
        color: #3d8ff7;
        margin: 0 auto;
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #3d8ff7;
        letter-spacing: 0;
      }
    }
  }

  footer {
    background: #2c59c3;
    color: #fff;
    height: 45px;
    line-height: 45px;
    text-align: center;
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #ffffff;
    letter-spacing: 0.26px;
    position: fixed;
    bottom: 0;
    width: 100%;
  }
}
</style>
